import React from "react";
import "./webinarLandingPage.css";
import { Helmet } from "react-helmet-async";

const DhanaAkarshanaThankYou = () => {
  const metaDataDetails = {
    MetaTitle:
      "Thank You for Booking Dhana Akarshana Homam | Myomnamo",
    MetaDescription:
      " Thank you for booking Dhana Akarshana Homam with Myomnamo. Our team will contact you soon with Puja details. May divine blessings bring you prosperity and peace",

    CanonicalTag: "https://www.myomnamo.com/services/book-puja/thank-you-dhana-akarshana-homam",
  };
  return (
    <>
      <Helmet>
        <title>{metaDataDetails?.MetaTitle}</title>
        <meta name="description" content={metaDataDetails?.MetaDescription} />
        <link rel="canonical" href={metaDataDetails?.CannonicalLink} />

        {/* Open Graph Tag */}

        {/* <!-- Open Graph tags --> */}
        <meta property="og:title" content={metaDataDetails?.OpenGraphTag} />
        <meta
          property="og:description"
          content="Celebrate Ganeshotsav with devotion & knowledge. Join our webinar to learn step-by-step Ganesh Puja rituals & traditions."
        />
        <meta property="og:title" content="Thank You for Booking Dhana Akarshana Homam | Myomnamo" />
        <meta property="og:description" content="Thank you for booking Dhana Akarshana Homam with Myomnamo. Our team will contact you soon with Puja details. May divine blessings bring you prosperity and peace." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.myomnamo.com/services/book-puja/thank-you-dhana-akarshana-homam" />
        <meta property="og:site_name" content="Myomnamo" />
        <meta property="og:image" content="" />
        <meta property="og:image:alt" content="Thank You for Booking Dhana Akarshana Homam" />



        {/* <!-- Twitter Card tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={metaDataDetails?.MetaTitle} />
        <meta
          name="twitter:description"
          content={metaDataDetails?.MetaDescription}
        />

        <script>
          {`
                    !function(f,b,e,v,n,t,s){
                      if(f.fbq) return; 
                      n=f.fbq=function(){n.callMethod ? 
                      n.callMethod.apply(n,arguments) : n.queue.push(arguments)};
                      if(!f._fbq) f._fbq=n;
                      n.push=n; n.loaded=!0; n.version='2.0';
                      n.queue=[]; t=b.createElement(e); t.async=!0;
                      t.src=v; s=b.getElementsByTagName(e)[0];
                      s.parentNode.insertBefore(t,s)
                    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', '24982247501377559');
                    fbq('track', 'PageView');
                  `}
        </script>
        <noscript>
          {`<img height="1" width="1" style="display:none" src="https://www.facebook.com/tr?id=24982247501377559&ev=PageView&noscript=1"/>`}
        </noscript>
      </Helmet>

      <div className="thankyou-container">
        <div className="thankyou-card">
          <h5 className="thankyou-title">Thank You for Booking the Dhana Akarshana Homam! 🙏</h5>
          <p className="thankyou-subtitle">
            Your booking for the Dhana Akarshana Homam has been successfully received. Our team will contact you shortly with further details.
          </p>

          <div className="thankyou-details">
            <h2>📌 Homam Details</h2>
            <ul>
              <li><strong>Homam Name:</strong> Dhana Akarshana Homam</li>
              <li><strong>Date:</strong> 29 October 2025</li>
              <li><strong>Time:</strong> 10:30 AM to 01:00 PM</li>
              <li><strong>Temple:</strong> Swarna Akarshana Bairavar Temple, Kumbakonam</li>
              <li><strong>Mode:</strong> Via live streaming, and we will provide the recorded video afterwards</li>

            </ul>
          </div>

          <div className="thankyou-note">
            <p>We are delighted to have you join this auspicious event and look forward to guiding you through this spiritual experience.</p>
            <p>
              Stay tuned! Our team will reach out to you soon with all necessary access details.
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default DhanaAkarshanaThankYou
